import { render } from "./item_stats.vue?vue&type=template&id=0fd4a6c7"
import script from "./item_stats.vue?vue&type=script&lang=js"
export * from "./item_stats.vue?vue&type=script&lang=js"

import "./item_stats.vue?vue&type=style&index=0&id=0fd4a6c7&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__